export const TOGGLE_MAP_BUTTON_DATA_TEST_ID = 'toggle-map-button';
export const BACK_ICON_DATA_TEST_ID = 'toggle-map-back-icon';
export const MAP_ICON_DATA_TEST_ID = 'toggle-map-map-icon';
